import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlatPickrComponent } from './component/flatpickr.component';
export class NgxFlatpickrkModule {
/**
 * @return {?}
 */
static forRoot() {
    return {
      ngModule: NgxFlatpickrkModule
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [
    FlatPickrComponent
  ],
  exports: [
    FlatPickrComponent
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NgxFlatpickrkModule_tsickle_Closure_declarations() {
/** @type {?} */
NgxFlatpickrkModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgxFlatpickrkModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
